import { Login } from 'components/Login';
import { LOGIN_TYPE } from 'utilities';

const ScreenLoginDealerName = () => {
  return <Login loginType={LOGIN_TYPE.DEALER_NAME} />;
};

export default ScreenLoginDealerName;
